import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Motivation from '@app/components/Landing/Motivation'
import Info from '@app/components/Landing/Info'
import About from '@app/components/Landing/About'
import Footer from '@app/components/Landing/Footer'
import TasksContainer from '@app/containers/students/Tasks'
import Content from '@app/components/students/Results/Content'
import { TourDescription } from '@app/components/Landing/CurrentTour'
import { Subject, Dates, Timing } from '@app/components/shared/StateLabel/Label'
import { getTourStatus, TourName, TourStatus } from '@app/helpers/tourStatusHelper'
import Timeline from "@app/components/shared/Timeline";
import Rewards from "@app/components/Landing/Rewards";
import Achievements from "@app/components/Landing/Achievements";

const ParticipationInfo = ({event, isStudent}) => {
  const tourStatus = getTourStatus(event);

  const textTimingForTeacher = [
    'Students can practise at their own pace with unlimited attempts.',
    'During this period, students can enter the Olympiad at any time. They will have 1\xa0hour to solve all tasks.',
    'During this period, the students who have scored the best in the previous round will be able to participate in quizzes with children from different schools in India.'
  ];

  const textTimingForStudent = [
    'You can practise at your own pace with unlimited attempts.',
    'During this period, you can enter the Olympiad at\xa0any time. You will have 1\xa0hour to\xa0solve all tasks.',
    'During this period, the students who have scored the best in the previous round will be able to participate in quizzes with children from different schools in India.'
  ];

  const textTiming = isStudent ? textTimingForStudent : textTimingForTeacher;

  return (
    <>
      <div className="section running-now-section" style={{paddingBottom: '30px'}}>
        <h1 className="plate-heading plate-heading--left">
          Practice Stage
        </h1>
        <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
          <div className="grid">
            <Subject event={event} tourName={'Warm-Up Stage'}/>
            <div className="grid">
              <Dates event={event} tour="trial"/>
              <Timing event={event} iconClassName="f--all-default" textTiming={textTiming[0]}/>
            </div>
          </div>
        </div>
      </div>
      <div className="section running-now-section" style={{paddingTop: 0, paddingBottom: '16px'}}>
        <h1 className="plate-heading plate-heading--left">
          Competition Stage
        </h1>
        <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
          <div className="grid">
            <Subject event={event} tourName={'DinoMath Olympiad'}/>
            <div className="grid">
              <Dates event={event} tour="main"/>
              <Timing event={event} iconClassName="f--all-default" textTiming={textTiming[1]}/>
            </div>
          </div>
        </div>
      </div>
      <div className="section running-now-section" style={{paddingTop: 0}}>
        <div className="plate plate--info plate--xl m-0" style={{border: '1px solid black'}}>
          <div className="grid">
            <Subject event={event} tourName={'Final Round'}/>
            <div className="grid">
              <Dates event={event} tour="final"/>
              <Timing event={event} iconClassName="f--all-default" textTiming={textTiming[2]}/>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const LandingPart = ({global}) => {
  return (
    <Fragment>
      <Timeline event={global.event} />
      <Achievements />
      <ParticipationInfo event={global.event}/>
      <Rewards />
      <Motivation/>
      <Info global={global}/>
      <About/>
      <Footer/>
    </Fragment>
  )
}

LandingPart.propTypes = {
  global: PropTypes.object.isRequired
}

export const CompetitionPart = ({global}) => {
  return (
    <Fragment>
      <Timeline event={global.event} />
      <Achievements />
      <ParticipationInfo event={global.event} isStudent={true}/>
      <Rewards />
      <Motivation/>
      <Info global={global}/>
      <About/>
      <Footer/>
    </Fragment>
  )
}

CompetitionPart.propTypes = {
  global: PropTypes.object.isRequired
}

export const AwardingPart = ({ student, global }) => {
  return (
    <Fragment>
      {
        student.isParticipated ? (
          <div className="section results-section">
            <div className="section__content pt-0 pb-1">
              <TasksContainer
                student={student}
                tour="main"
                className="rewarding"
                ChildComponent={Content}
              />
            </div>
          </div>
        ) : null
      }
      <Achievements />
      <ParticipationInfo event={global.event} isStudent={true}/>
      <Rewards />
      <Motivation />
      <Info global={global} />
      <About />
      <Footer />
    </Fragment>
  )
}

AwardingPart.propTypes = {
  global: PropTypes.object.isRequired,
  student: PropTypes.any.isRequired
}

export const PreparatoryAwardingPart = ({ global }) => {
  return (
    <Fragment>
      <Rewards />
      <Motivation />
      <Info global={global} />
      <About />
      <Footer />
    </Fragment>
  )
}

PreparatoryAwardingPart.propTypes = {
  global: PropTypes.object.isRequired
}
